import { useState, useEffect } from 'react';
import { Box, CircularProgress, Grid, MenuItem } from '@mui/material';

import { toast } from 'react-toastify';
import { CustomSelect, HumbeeTabs } from '../../../v2/MUI_custom_component';
import LinkedFirmCard from './Components/LinkedFirmCard';
import NPSPortfolioCard from './Components/NPSPortfolioCard';
import AccumulatedPortfolioCard from './Components/AccumulatedPortfolioCard';
import { GrossGAPSection } from './Components/QuarterAccordion';
import NetGAPAllocatedSection from './Components/NetGAPAllocatedSection';
import GAPCard from './Components/GAPCard';
import { getGAPDetails } from './APIs/action';

const CumulativeGAP = () => {
  const [data, setData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [selectedFY, setSelectedFY] = useState('');
  const [activePortfolioTab, setActivePortfolioTab] = useState(0);

  const fetchData = async () => {
    setLoader(true);
    const result = await getGAPDetails();
    setLoader(false);
    if (!result?.error) {
      setData(result?.data || result);
      const firstFY = result?.data?.gap_info?.[0]?.financial_year || result?.gap_info?.[0]?.financial_year;
      if (firstFY) setSelectedFY(firstFY);
    } else {
      toast.error(result?.message || 'Failed to fetch GAP details');
    }
  };
  useEffect(() => {
      fetchData();
  }, []);

  if (loader) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) return null;

  const fyOptions = data.gap_info?.map((g) => g.financial_year) || [];
  const activeFYData = data.gap_info?.find((g) => g.financial_year === selectedFY) || data.gap_info?.[0];

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <GAPCard benefitCard={data.benefit_card} />
      </Box>
      {data.firms?.length > 0 && (
        <Box sx={{ display: 'flex', gap: 1, mb: 2, overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
          {data.firms.map((firmFields, idx) => (
            <LinkedFirmCard key={idx} fields={firmFields} />
          ))}
        </Box>
      )}
      {data.accumulated_portfolio && (
        <Box sx={{ mb: 2, width: { md: '50%' } }}>
          <AccumulatedPortfolioCard portfolio={data.accumulated_portfolio} />
        </Box>
      )}
      {data.nps_portfolios?.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <HumbeeTabs
            data={data.nps_portfolios}
            currentTab={activePortfolioTab}
            onChange={(_, v) => setActivePortfolioTab(v)}
            getTabLabel={(p) => p.beneficiary_name}
            getTabKey={(p) => p.beneficiary_id}
            renderTabContent={(portfolio) => (
              <NPSPortfolioCard portfolio={portfolio} />
            )}
          />
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} md={activeFYData?.net_gap_allocated ? 12 : 6}>
          {fyOptions.length > 0 && (
            <Box sx={{ mb: 2 }}>
              <CustomSelect
                label="Financial Year"
                value={selectedFY}
                onChange={(e) => setSelectedFY(e.target.value)}
                fullWidth
              >
                {fyOptions.map((fy) => (
                  <MenuItem key={fy} value={fy}>
                    {fy}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Box>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <GrossGAPSection grossGapSummary={activeFYData?.gross_gap_summary} subject_to_tds={data.subject_to_tds} />
        </Grid>
        {activeFYData?.net_gap_allocated && (
          <Grid item xs={12} md={6}>
            <NetGAPAllocatedSection netGapAllocated={activeFYData?.net_gap_allocated} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default CumulativeGAP;
